import OrderDetailByDelivery from './OrderDetailListing/OrderDetailTabsData/OrderDetailByDelivery';
import OrderDetailByLineItem from './OrderDetailListing/OrderDetailTabsData/OrderDetailByLineItem';
import store from 'src/storeWire';

class CommonOrderDetail {
    //MainPage
    static chain = {
        OrderDetailTabsListing: { param_value: 'LINE_ITEMS', element: OrderDetailByLineItem }
    };
    static param_key = '__c';
    static redux_key = 'OrderDetail__Component__Loader';
    static default_component = CommonOrderDetail.chain.OrderDetailTabsListing;
    static chain_OrderDetailTabList = {
        DELIVERY: {
            name: 'BY DELIVERY',
            param_value: 'DELIVERY',
            element: OrderDetailByDelivery
        },
        LINE_ITEMS: {
            name: 'BY LINE ITEMS',
            param_value: 'LINE_ITEMS',
            element: OrderDetailByLineItem
        }
    };

    static param_key_OrderDetailTabList = '__c_OrderDetailTabList';
    static redux_key_OrderDetailTabList = 'OrderDetailTabList__Component__Loader';
    static default_component_OrderDetailTabList = CommonOrderDetail.chain_OrderDetailTabList.LINE_ITEMS;
}

export default CommonOrderDetail;